<template>
  <div id="sidebar-storage-view">
    <div class="px-6 py-2 mb-4 flex flex-col">
      <div id="storage-status" class="flex item-center">
        <div class="flex items-center">
          <feather-icon icon="ServerIcon" svgClasses="h-10 w-10">
          </feather-icon>
        </div>
        <div class="px-4 item-center w-full">
          <div class="flex h-1/2">
            {{ usageText }} / {{ maxCapacityText }}
          </div>
          <div class="flex h-1/2 py-2">
            <vs-progress
              :percent="usageCapacityPercent"
              :color="statusbarColor"
            >
            </vs-progress>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import { UnitUtil } from "@/utils";

const {
  mapActions: mapActionsOfEnterpriseDocumentManager,
  mapState: mapStateOfEnterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");


const MAX_CAPACITY = 10 * 1024 * 1024 * 1024; //10GB

export default {
  mixins: [ColorMixin],
  computed: {
    ...mapStateOfEnterpriseDocumentManager([
      "storageMaxCapacity", "storageUsage"
    ]),
    usageText () {
      return UnitUtil.formatBytes(this.storageUsage, 1);
    },

    maxCapacityText () {
      return UnitUtil.formatBytes(MAX_CAPACITY, 1);
    },

    usageCapacityPercent () {
      const percent = (this.storageUsage / MAX_CAPACITY) * 100;
      return parseInt(percent, 10)
    },

    storageState () {
      if (this.usageCapacityPercent >= 100) {
        return "full"
      }
      if (this.usageCapacityPercent >= 90) {
        return "warn"
      }
      return "normal"
    },

    statusbarColor () {
      switch (this.storageState) {
        case "normal":
          return this.AISEA_COLOR.BLUE
        case "warn":
          return "#FADA0A"
        case "full":
          return this.AISEA_COLOR.RED
        default:
          return null;
      }
    }

  },
  methods: {
    ...mapActionsOfEnterpriseDocumentManager([
      "getStorageCapacity",]),
  },
  mounted() {
    this.getStorageCapacity()
  }
}
</script>

<style>
</style>